import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Lungs icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Lungs } from '@sravni/design-system-icons'
 *
 * <Lungs />
 * ```
 */
var Lungs = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Lungs", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.257 6.543V2.929M8.742 2.929v3.614a1.886 1.886 0 0 1-1.886 1.886v0M13.143 8.429a1.886 1.886 0 0 1-1.886-1.886M13.143 10.786A4.213 4.213 0 0 1 10 9.37M6.856 10.786A4.213 4.213 0 0 0 10 9.37", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.179 13.14v1.074c0 .893.504 1.709 1.302 2.108l.828.413c2.09 1.045 4.548-.474 4.548-2.81V9.097c0-.713-.242-1.405-.689-1.963l-1.4-1.748c-.697-.873-1.749-1.057-2.625-.744M8.821 13.14v1.074c0 .893-.504 1.709-1.303 2.108l-.827.413c-2.09 1.045-4.548-.474-4.548-2.81V9.097c0-.713.242-1.405.689-1.963L4.23 5.386c.698-.873 1.75-1.057 2.626-.744", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Lungs };
//# sourceMappingURL=Lungs.js.map
